import React from 'react';
import { clamp } from 'lodash';

import { HeadingLevelProvider, useHeadingLevel } from '@zapier/common-utils';

type Props = {
  children: React.ReactNode;
};

const HeadingLevel = ({ children }: Props) => {
  const { level } = useHeadingLevel();
  const nextLevel = clamp(level + 1, 1, 6);
  return (
    <HeadingLevelProvider level={nextLevel}>{children}</HeadingLevelProvider>
  );
};

export default HeadingLevel;
